import React, { Component } from "react";
import Wrp from '../../../../../../../hoc/Wrp/Wrp';
// import {Card,CardBody} from '../../../../../../../hoc/Card';
// import BootstrapRow from '../../../../../../../hoc/BootstrapRow';
// import BootstrapColumn from '../../../../../../../hoc/BootstrapColumn';
// import Datetime from 'react-datetime';
// import moment from 'moment';
// import 'react-datetime/css/react-datetime.css';
// import {getDateFormat} from '../../../../../../../../Utils/UserFunctions';
import {WeeksSequenceList,WeeksList} from '../defaultList';
class RepeatEveryMonths extends Component {

  constructor(props) {
    super(props);
    this.state = {
      // dt: moment(),
      // setDt: moment(),
      isReminderPopup:false,
      isReminderSelected:false
    }
  }
  render() {
    const  {
      reminderJson,
      actionChangeHandler,
    } = this.props;
    return (
      <Wrp>
        {(reminderJson.repeatOption==='DAY')?
          <div className="d-flex w-100 mb-3">
            <div className="input-group">
              <div className="input-group-prepend">
                <span className="input-group-text">on day </span>
              </div>
              <input 
                type="number" 
                max={31} 
                min={1} 
                value={reminderJson.repeat_dom}
                onChange={e=>actionChangeHandler(e,'repeat_dom',e.target.value)}
                className="form-control" />
              <div className="input-group-prepend">
                <span className="input-group-text">of the month(s)</span>
              </div>
            </div>
          </div>
        :
        <div className="d-flex w-100 mb-3">
          <div className="input-group">
            <div className="input-group-prepend">
              <span className="input-group-text">on</span>
            </div>
            <select className="form-control" value={reminderJson.repeat_weekseq} onChange={e=>actionChangeHandler(e,'repeat_weekseq',e.target.value)}>
              {WeeksSequenceList().map((seq,itemIndex)=>{
                    return(
                        <option key={itemIndex} value={seq.value}>{seq.label}</option>
                    )
                })}
            </select>
            <select className="form-control" value={reminderJson.repeat_weekday} onChange={e=>actionChangeHandler(e,'repeat_weekday',e.target.value)}>
              {WeeksList().map((week,itemIndex)=>{
                    return(
                        <option key={itemIndex} value={week.value}>{week.label}</option>
                    )
                })}
            </select>
          </div>
        </div>
      }
      </Wrp>    
    );
  } 
}

export default RepeatEveryMonths;
